module.exports = __webpack_public_path__ + "static/car.2d94541b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/car.jpg
// module id = 1502
// module chunks = 19843951674672